/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it support regular expressions?`)
};

const es_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Soporta expresiones regulares?`)
};

const de_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützt es reguläre Ausdrücke?`)
};

const nl_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteunt het reguliere uitdrukkingen?`)
};

const fr_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prend-il en charge les expressions régulières ?`)
};

const it_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporta espressioni regolari?`)
};

const pt_br2_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele suporta expressões regulares?`)
};

const pt_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporta expressões regulares?`)
};

const ja_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正規表現に対応していますか？`)
};

const zh_fr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它支持正则表达式吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq1_q", locale)
	if (locale === "en") return en_fr_faq1_q(inputs)
	if (locale === "es") return es_fr_faq1_q(inputs)
	if (locale === "de") return de_fr_faq1_q(inputs)
	if (locale === "nl") return nl_fr_faq1_q(inputs)
	if (locale === "fr") return fr_fr_faq1_q(inputs)
	if (locale === "it") return it_fr_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq1_q(inputs)
	if (locale === "pt") return pt_fr_faq1_q(inputs)
	if (locale === "ja") return ja_fr_faq1_q(inputs)
	return zh_fr_faq1_q(inputs)
};